import { render, staticRenderFns } from "./audio-element.vue?vue&type=template&id=4e5cf9f6&"
import script from "./audio-element.vue?vue&type=script&lang=js&"
export * from "./audio-element.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports